import { render, staticRenderFns } from "./HistoricoVinculo.vue?vue&type=template&id=27a56566"
import script from "./HistoricoVinculo.vue?vue&type=script&lang=js"
export * from "./HistoricoVinculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports